import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_component_ErrorMessage, { name: _ctx.name }, {
    default: _withCtx(({ message }) => [
      _createVNode(_Transition, {
        name: "o-anim-fade-300",
        mode: "out-in",
        appear: ""
      }, {
        default: _withCtx(() => [
          message
            ? (_openBlock(), _createElementBlock("div", _mergeProps({
                key: 0,
                key: message,
                class: "text-roman"
              }, _ctx.$attrs, { role: "alert" }), _toDisplayString(message), 17))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["name"]))
}